// extracted by mini-css-extract-plugin
module.exports = {"v13uegxl":"v13uegxl"};